<div class="info-edit" [formGroup]="form">
  <div class="info-edit__block">
    <div>
      <tui-input
        class="field"
        tabindex="1"
        formControlName="title"
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [tuiTextfieldSize]="tuiElementLargeSize"
      >
        {{ 'components.pageInfoEdit.fields.title' | translate }}

        <span class="tui-required"></span>

        <input tuiTextfieldLegacy appTestingId="infoEdit.input.title" />
      </tui-input>

      <tui-error
        *ngIf="controlValueError('title') as errorText"
        [error]="'common.labels.maxLengthError' | translate: { value: errorText }"
      ></tui-error>
    </div>

    <div>
      <tui-textarea
        class="field field_height_min"
        tabindex="2"
        formControlName="contentText"
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [tuiTextfieldSize]="tuiElementLargeSize"
        [expandable]="true"
      >
        {{ 'components.pageInfoEdit.fields.contentText' | translate }}

        <span class="tui-required"></span>

        <textarea tuiTextfieldLegacy appTestingId="infoEdit.input.contentText"></textarea>
      </tui-textarea>

      <tui-error
        *ngIf="controlValueError('contentText') as errorText"
        [error]="'common.labels.maxLengthError' | translate: { value: errorText }"
      ></tui-error>
    </div>

    <app-field-wrapper
      class="field"
      [text]="'components.pageInfoEdit.fields.showInMenu' | translate"
      [size]="tuiElementMediumSize"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
    >
      <app-toggle
        tabindex="3"
        formControlName="showInMenu"
        appTestingId="infoEdit.button.showInMenu"
        [size]="tuiElementMediumSize"
      ></app-toggle>
    </app-field-wrapper>

    <tui-input-number
      class="field"
      tabindex="4"
      formControlName="sortOrder"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.pageInfoEdit.fields.sortOrder' | translate }}

      <span class="tui-required"></span>

      <input tuiTextfieldLegacy appTestingId="infoEdit.input.sortOrder" />
    </tui-input-number>
  </div>

  <app-contacts
    class="info-edit__block"
    formControlName="contacts"
    [allowCreating]="allowEditing$ | async"
    [allowEditing]="allowEditing$ | async"
    [allowDeleting]="allowEditing$ | async"
    [loading]="loading"
  ></app-contacts>

  <div class="info-edit__buttons">
    <button
      *ngIf="allowEditing$ | async"
      tuiButton
      class="info-edit-button"
      type="button"
      appTestingId="infoEdit.button.save"
      [appearance]="'primary'"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [size]="tuiElementLargeSize"
      (click)="onClickSaveButton()"
    >
      {{ 'common.buttons.save' | translate }}
    </button>

    <button
      tuiButton
      class="info-edit-button"
      type="button"
      appTestingId="infoEdit.button.cancel"
      [appearance]="'secondary'"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [size]="tuiElementLargeSize"
      (click)="onClickCancelButton()"
    >
      {{ 'common.buttons.cancel' | translate }}
    </button>
  </div>
</div>
